var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import { store } from '@components/sale.basket.basket.line/store-context';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useContext } from 'react';
import { getBasket } from './utils';
import Item from './Item';
import CircularProgress from '@material-ui/core/CircularProgress';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        tableCarts: {
            overflowY: 'auto',
            marginRight: '5px',
            marginTop: '10px',
            height: '85px',
        },
    });
});
/**
 * Тело попапа
 * @param param0
 * @returns
 */
var Popup = function () {
    var classes = useStyles();
    var _a = useContext(store), _b = _a.state, count = _b.count, cartItems = _b.cartItems, isInitCartItem = _b.isInitCartItem, basePrice = _b.basePrice, basePriceFormat = _b.basePriceFormat, price = _b.price, priceFormat = _b.priceFormat, isAjax = _b.isAjax, favItems = _b.favItems, dispatch = _a.dispatch;
    // Если
    useEffect(function () {
        if (isInitCartItem) {
            return;
        }
        getBasket().then(function (response) {
            dispatch({
                type: 'setBasketData',
                payload: __assign(__assign({}, response.data.data), { isInitCartItem: true }),
            });
        });
    }, []);
    if (!isInitCartItem) {
        return (React.createElement(React.Fragment, null));
    }
    return (React.createElement("div", { className: "bx-basket bx-opener open" },
        React.createElement("div", { className: "btn-wrap" }, count ? (React.createElement("a", { href: "/personal/order/make/" }, isAjax ? (React.createElement(CircularProgress, { style: { color: 'red' }, size: 16 })) : ('Оформить заказ'))) : null),
        React.createElement("div", { className: classes.tableCarts },
            React.createElement("table", { className: "table hcart" },
                React.createElement("tbody", null, cartItems.map(function (item) { return ((item.MAX_QUANTITY <= 0) ? null : React.createElement(Item, { key: item.ID, data: item })); }))))));
};
export default React.memo(Popup);
